const imgMediaCardStyle = {
  card: {
    maxWidth: 400,
    marginLeft: "auto",
    marginRight: "auto",
    height: "100%"
  },
  cardActionArea: {
    height: "100%"
  },
  cardContent: {
    flexGrow: 1
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover"
  }
};

export default imgMediaCardStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/components/imgMediaCardStyle.jsx